'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('./icon.js');
require('./browser-05a2bba8.js');
require('react-dom');
require('./_commonjsHelpers-3fc1f64e.js');
require('./_react_commonjs-external-30e5c7b3.js');
require('./_prop-types_commonjs-external-c51b2bd5.js');
var isFunction = _interopDefault(require('lodash/isFunction'));
require('./react-lifecycles-compat.es-59afd828.js');
require('./_react-dom_commonjs-external-3c49a59a.js');
var index = require('./index-cd777c24.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  &__overlay {\n    z-index: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    opacity: 0;\n    transition: opacity 300ms ease-in-out;\n    top: ", ";\n    @media screen and (max-width: 991px) {\n      z-index: ", ";\n      top: ", ";\n    }\n    &.ReactModal__Overlay--after-open {\n      opacity: 1;\n    }\n\n    &.ReactModal__Overlay--before-close {\n      opacity: 0;\n    }\n  }\n\n  &__content {\n    position: relative;\n    border: 1px solid ", ";\n    background: ", ";\n    overflow: auto;\n    outline: none;\n    transition: opacity 300ms ease-in-out;\n    transition: transform 300ms ease-in-out;\n    transform: ", ";\n    opacity: 1;\n    height: 100%;\n    width: ", ";\n    &.ReactModal__Content--after-open {\n      transform: translateY(0);\n    }\n    &.ReactModal__Content--before-close {\n      transform: ", ";\n    }\n  }\n"], ["\n  &__overlay {\n    z-index: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    opacity: 0;\n    transition: opacity 300ms ease-in-out;\n    top: ", ";\n    @media screen and (max-width: 991px) {\n      z-index: ", ";\n      top: ", ";\n    }\n    &.ReactModal__Overlay--after-open {\n      opacity: 1;\n    }\n\n    &.ReactModal__Overlay--before-close {\n      opacity: 0;\n    }\n  }\n\n  &__content {\n    position: relative;\n    border: 1px solid ", ";\n    background: ", ";\n    overflow: auto;\n    outline: none;\n    transition: opacity 300ms ease-in-out;\n    transition: transform 300ms ease-in-out;\n    transform: ", ";\n    opacity: 1;\n    height: 100%;\n    width: ", ";\n    &.ReactModal__Content--after-open {\n      transform: translateY(0);\n    }\n    &.ReactModal__Content--before-close {\n      transform: ", ";\n    }\n  }\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  z-index: 1500;\n  top: 20px;\n  right: 20px;\n  width: 15px;\n  height: 15px;\n  color: #d8d8d8;\n  font-size: 17px;\n  &:hover {\n    cursor: pointer;\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  z-index: 1500;\n  top: 20px;\n  right: 20px;\n  width: 15px;\n  height: 15px;\n  color: #d8d8d8;\n  font-size: 17px;\n  &:hover {\n    cursor: pointer;\n    color: ", ";\n  }\n"]);

function ReactModalAdapter(_ref) {
  var className = _ref.className,
      rootId = _ref.rootId,
      props = _babelHelpers.objectWithoutProperties(_ref, ["className", "rootId"]);

  var contentClassName = className + "__content";
  var overlayClassName = className + "__overlay";
  index.ReactModal.setAppElement(rootId);
  return React__default.createElement(index.ReactModal, _babelHelpers._extends({
    portalClassName: className,
    className: contentClassName,
    overlayClassName: overlayClassName
  }, props));
}

var StyledModal = styled__default(ReactModalAdapter)(_templateObject, function (props) {
  return props.zIndex || "9999";
}, function (props) {
  return props.top || "0px";
}, function (props) {
  return props.mZIndex || "9999";
}, function (props) {
  return props.mTop || "0px";
}, settings.COLOR.lineGray, settings.COLOR.white, function (props) {
  return props.translateYValue ? "translateY(" + props.translateYValue + ")" : "translateY(50%)";
}, function (props) {
  return props.customWidth || "100%";
}, function (props) {
  return props.translateYValue ? "translateY(" + props.translateYValue + ")" : "translateY(50%)";
});

var CloseButtonWrapper = styled__default.div(_templateObject2, settings.COLOR.textBlack);

var RentSpreeBaseFullPageModal = function RentSpreeBaseFullPageModal(_ref) {
  var id = _ref.id,
      rootId = _ref.rootId,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      modalSize = _ref.modalSize,
      shouldCloseOnOverlayClick = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnEsc = _ref.shouldCloseOnEsc,
      onAfterOpen = _ref.onAfterOpen,
      onAfterClose = _ref.onAfterClose,
      closeButton = _ref.closeButton,
      children = _ref.children,
      mTop = _ref.mTop,
      top = _ref.top,
      zIndex = _ref.zIndex,
      mZIndex = _ref.mZIndex,
      translateYValue = _ref.translateYValue;

  var disabledScrolling = function disabledScrolling() {
    if (isFunction(onAfterOpen)) {
      onAfterOpen();
    }
    document.body.style.overflow = "hidden";
  };
  var enabledScrolling = function enabledScrolling() {
    if (isFunction(onAfterClose)) {
      onAfterClose();
    }
    document.body.style.overflow = "auto";
    document.body.style.paddingRight = "0";
  };

  return React__default.createElement(
    StyledModal,
    {
      id: id,
      rootId: rootId,
      contentLabel: id,
      isOpen: isOpen,
      onAfterOpen: disabledScrolling,
      onRequestClose: onClose,
      shouldCloseOnEsc: shouldCloseOnEsc,
      shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
      onAfterClose: enabledScrolling,
      closeTimeoutMS: 300,
      modalSize: modalSize,
      mTop: mTop,
      top: top,
      zIndex: zIndex,
      mZIndex: mZIndex,
      translateYValue: translateYValue },
    closeButton && React__default.createElement(
      CloseButtonWrapper,
      { onClick: onClose },
      React__default.createElement(icon.Icon, { name: "close", size: "sm" })
    ),
    children
  );
};

RentSpreeBaseFullPageModal.propTypes = {
  /** id of the modal */
  id: PropTypes$1.string,
  /** indicator to show modal */
  isOpen: PropTypes$1.bool.isRequired,
  /** function that will get call after the modal is open */
  onAfterOpen: PropTypes$1.func,
  /** function that will get call when close modal */
  onClose: PropTypes$1.func.isRequired,
  /** indicator for call close modal function when click on overlay */
  shouldCloseOnOverlayClick: PropTypes$1.bool,
  /** indicator for show close button on the top right */
  closeButton: PropTypes$1.bool,
  /** indicator for close modal when press ESC */
  shouldCloseOnEsc: PropTypes$1.bool,
  /** function that will get call after the modal is close */
  onAfterClose: PropTypes$1.func,
  /** id of the root of your app. The modal need the root id to mount itself to the root component */
  rootId: PropTypes$1.string,
  /** top style of the modal on mobile view */
  mTop: PropTypes$1.string,
  /** top style of the modal on desktop view */
  top: PropTypes$1.string,
  /** slider from bottom 100% = bottom */
  translateYValue: PropTypes$1.string,
  /** zIndex styled for modal */
  zIndex: PropTypes$1.string,
  /** zIndex styled for modal mobile */
  mZIndex: PropTypes$1.string
};

RentSpreeBaseFullPageModal.defaultProps = {
  shouldCloseOnOverlayClick: true,
  closeButton: true,
  shouldCloseOnEsc: true,
  rootId: "#app"
};
RentSpreeBaseFullPageModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RentSpreeBaseFullPageModal",
  "props": {
    "shouldCloseOnOverlayClick": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for call close modal function when click on overlay"
    },
    "closeButton": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for show close button on the top right"
    },
    "shouldCloseOnEsc": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicator for close modal when press ESC"
    },
    "rootId": {
      "defaultValue": {
        "value": "\"#app\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "id of the root of your app. The modal need the root id to mount itself to the root component"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "id of the modal"
    },
    "isOpen": {
      "type": {
        "name": "bool"
      },
      "required": true,
      "description": "indicator to show modal"
    },
    "onAfterOpen": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that will get call after the modal is open"
    },
    "onClose": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "function that will get call when close modal"
    },
    "onAfterClose": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "function that will get call after the modal is close"
    },
    "mTop": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "top style of the modal on mobile view"
    },
    "top": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "top style of the modal on desktop view"
    },
    "translateYValue": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "slider from bottom 100% = bottom"
    },
    "zIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "zIndex styled for modal"
    },
    "mZIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "zIndex styled for modal mobile"
    }
  }
};

module.exports = RentSpreeBaseFullPageModal;
//# sourceMappingURL=full-page-modal.js.map
